module.exports = __webpack_public_path__ + "img/brand-right-shapes.44a3a523.png";